<template>
  <section class="max-w-5xl mx-auto py-10 px-6 space-y-10">
<div class="text-center mb-8">
  <!-- Linie oben -->
  <div class="w-40 h-[3px] mx-auto mb-3 rounded-full bg-gradient-to-r from-blue-100 via-green-100 to-blue-200"></div>

  <!-- Überschrift -->
  <h1 class="text-2xl font-semibold text-gray-800">
    Book a Session
  </h1>

  <!-- Linie unten -->
  <div class="w-40 h-[3px] mx-auto mt-3 rounded-full bg-gradient-to-l from-blue-100 via-green-100 to-blue-200"></div>
</div>

    <!-- Calendly Popup Button -->
    <div class="text-center mb-12">
      <button
        @click="openCalendly"
        class="inline-block bg-indigo-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-indigo-700 transition"
      >
        Schedule time with me
      </button>
    </div>

    <!-- Alert -->
    <div v-if="showAlert" :class="alertClass" class="mb-4 p-3 rounded-md text-white text-center">
      {{ alertMessage }}
    </div>

    <!-- Kontaktformular -->
    <form @submit.prevent="handleSubmit" class="space-y-6 bg-white shadow-lg rounded-lg p-8 mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Name -->
        <div>
          <label for="name" class="block text-sm font-medium mb-1">Full Name</label>
          <input
            v-model="form.name"
            type="text"
            id="name"
            required
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <!-- Email -->
        <div>
          <label for="email" class="block text-sm font-medium mb-1">Email</label>
          <input
            v-model="form.email"
            type="email"
            id="email"
            required
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
      </div>

      <!-- Message -->
      <div>
        <label for="message" class="block text-sm font-medium mb-1">Message</label>
        <textarea
          v-model="form.message"
          id="message"
          rows="5"
          required
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        ></textarea>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="w-full bg-indigo-600 text-white font-semibold py-3 px-6 rounded-md hover:bg-indigo-700 transition"
      >
        {{ isLoading ? "Sending..." : "Send Message" }}
      </button>
    </form>
  </section>
</template>

<script setup>
/* global Calendly */
import { reactive, ref, computed } from "vue";
import emailjs from "@emailjs/browser";

// Form data
const form = reactive({
  name: "",
  email: "",
  message: "",
});

// Loading & Alert
const isLoading = ref(false);
const showAlert = ref(false);
const alertType = ref("success");
const alertMessage = ref("");

// Alert CSS based on type
const alertClass = computed(() => alertType.value === "success" ? "bg-green-500" : "bg-red-500");

// Show alert helper
const showAlertMessage = (type, message) => {
  alertType.value = type;
  alertMessage.value = message;
  showAlert.value = true;
  setTimeout(() => showAlert.value = false, 5000);
};

// Calendly popup
const openCalendly = () => {
  if (window.Calendly) {
    Calendly.initPopupWidget({ url: "https://calendly.com/melissamctherapy" });
  } else {
    console.warn("Calendly script not loaded yet");
  }
};

// Form submit
const handleSubmit = async () => {
  isLoading.value = true;

  try {
    // reCAPTCHA v3 Token abrufen
const token = await window.grecaptcha.execute("6LeaeMYrAAAAAElKRdpI-eJ4IBQOjeUKX059MJff", { action: "submit" });

    // Daten inkl. Token an EmailJS senden oder an Server
    await emailjs.send(
      "service_ijroev9",
      "template_4pc8e0t",
      {
        from_name: form.name,
        from_email: form.email,
        to_email: "Melissamctherapy@gmail.com",
        message: form.message,
        "g-recaptcha-response": token, // Token hinzufügen
      },
      "OH_WWCHPwy7AcUYGO"
    );

    showAlertMessage("success", "Your message has been sent!");
    form.name = "";
    form.email = "";
    form.message = "";

  } catch (err) {
    console.error(err);
    showAlertMessage("danger", "Something went wrong!");
  } finally {
    isLoading.value = false;
  }
};

</script>
